/*
* Copyright (C) Regione Lombardia
*/
import { HttpClient, HttpResponseBase, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import { doDownload } from '@core/utilities';
import { environment } from '@env/environment';
import {
    DialogMessage,
    DialogMessageLevel,
    FormDataSessionEnum
} from '@models';
import { BehaviorSubject, tap } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UtilsService {

    public loader$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public navigationLoader$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public forceLoader$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public messages$: BehaviorSubject<DialogMessage | null> = new BehaviorSubject<DialogMessage | null>(null);

    constructor(private http: HttpClient) {}

    /* Loading */
    public inLoading(state: boolean) { this.loader$.next(state); }
    public inNavigationLoading(state: boolean) { this.navigationLoader$.next(state); }
    public forceLoading(state: boolean) { this.forceLoader$.next(state); }

    /* Dialog messages */
    public showError(message: string) { this.messages$.next({level: DialogMessageLevel.ERROR, message}); }
    public showWarning(message: string) { this.messages$.next({level: DialogMessageLevel.WARNING, message}); }
    public showSuccess(message: string) { this.messages$.next({level: DialogMessageLevel.SUCCESS, message}); }
    public showInfo(message: string) { this.messages$.next({level: DialogMessageLevel.INFO, message}); }

    /* Generic response */
    public genericResponse204NoContent(response: HttpResponseBase) {
        if (response.status !== HttpStatusCode.NoContent) {
            return false;
        }
        this.showSuccess(CoreI18nConfigs.messages.genericSuccess);
        return true;
    }

    /* Form data in sessione */
    public getFormDataSession(key: FormDataSessionEnum) {
        return sessionStorage.getItem(key) ? JSON.parse(sessionStorage.getItem(key) || '{}') : null;
    }
    public setFormDataSession(key: FormDataSessionEnum, values: any) {
        sessionStorage.setItem(key, JSON.stringify(values));
    }

    public downloadManuale() {
        return this.http.get(`${environment.urlApi}/public/manuale`, {
            responseType: 'blob'
        }).pipe(
            tap((response) =>
                doDownload(
                    response,
                    'manuale-ods',
                    'pdf')
                )
            )
    }

}
